import React from 'react'

import {
    RichTextEditorPadrao
} from './RichTextEditorPadrao'

import {
    GridContainer,
    GridItem12,
} from '../Grid/Grid'



export const RichTextEditorViewerPadrao = ( props ) => {

    return (
        <GridContainer>
            <GridItem12>
                <RichTextEditorPadrao
                    readOnly={true}
                    {...props}
                />
            </GridItem12>
        </GridContainer>
    )
}